const INIT_STATE = {
  searchParams: {
    searchCode: '01', //01:고객명, 02:주민등록번호(앞6자리), 03:휴대전화번호(뒤4자리)
    searchValue: '', //검색값
    searchCustid: '',
  },
  interestCustomerList: [],
  totalCount: 0,
  interestParam: {
    custName: '',
    custId: '',
    userId: '',
  },
};

const interestCustomerReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case 'INIT_STATE': {
      return INIT_STATE;
    }
    case 'GET_INTERESTING_CUSTOMER_LIST': {
      return {
        ...state,
        searchParams: action.payload,
      };
    }
    case 'GET_INTERESTING_CUSTOMER_SUCCESS': {
      return {
        ...state,
        interestCustomerList: action.payload.pagingResult?.list,
        totalCount: action.payload.pagingResult?.rows,
      };
    }
    case 'UPDATE_SEARCH_PARAMS_INFO':
      return {
        ...state,
        searchParams: {
          ...state.searchParams,
          ...action.payload,
        },
      };
    case 'UPDATE_SEARCH_PARAMS_CLEAR':
      return {
        ...state,
        interestCustomerList: INIT_STATE.interestCustomerList,
        searchParams: INIT_STATE.searchParams,
      };
    case 'UPDATE_INTEREST_PARAM':
      return {
        ...state,
        interestParam: {
          ...state.interestParam,
          ...action.payload,
        },
      };
    case 'UPDATE_INTEREST_PARAM_CLEAR':
      return {
        ...state,
        interestParam: INIT_STATE.interestParam,
      };

    default:
      return state;
  }
};

export default interestCustomerReducer;
